import { DashboardLayout } from "../_root"
import Dashboard from "@/app/(dashboard)/Dashboard"
import { createRoute } from "@tanstack/react-router"
import {
    ChildManagement,
    AssessmentHistory,
    QuestionnaireViewer,
    AssessmentFlow,
    AssessmentReport
} from "@/components/app/parent"
import { QuestionnaireManagement, AuditLogs, UserManagement } from "@/components/app/admin"

export const DashboardRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "/",
    component: Dashboard
})

export const ChildrenRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "children",
    component: ChildManagement
})

export const HistoryRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "history",
    component: AssessmentHistory
})

export const QuestionnaireRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "questionnaire",
    component: QuestionnaireViewer
})

export const AssessmentRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "assessment/$childId",
    component: AssessmentFlow
})

export const AssessmentStartRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "assessment",
    component: AssessmentFlow
})

export const ReportRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "reports/$assessmentId",
    component: AssessmentReport
})

export const AdminQuestionnairesRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "admin/questionnaires",
    component: QuestionnaireManagement
})

export const AdminAuditLogsRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "admin/audit-logs",
    component: AuditLogs
})

export const AdminUsersRoute = createRoute({
    getParentRoute: () => DashboardLayout,
    path: "admin/users",
    component: UserManagement
})